<template>
  <mu-card id="frequently-asked">
    <mu-card-header
      titleClass="blueTitle largeTitle"
      :title="$t('message.discussionFaqTitle')"
      :subTitle="$t('message.discussionFaqSubTitle')">
    </mu-card-header>
    <mu-list>
      <div v-if="isLoading === true">
        <mu-list-item
          v-for="(item, index) in 5"
          :key="'dummy-loader' + index"
        >
          <mu-linear-progress
            slot="describe"
            color="#d9d9d9"
            style="width: 50%; height: 12px;background: rgb(214, 214, 214); margin-bottom: 8px"
          ></mu-linear-progress>

          <mu-linear-progress
            slot="describe"
            color="#d9d9d9"
            style="width: 16%; height: 12px;background: rgb(214, 214, 214); margin-bottom: 8px"
          ></mu-linear-progress>

        </mu-list-item>
      </div>
      <mu-list-item
        v-if="isLoading === false"
        v-for="(item, index) in data"
        :key="'frequent-question-' + index"
        :title="encode(item.question)"
        class="faq"
        @click="goToQuestion(item.question_id)"
      >
      </mu-list-item>
    </mu-list>
  </mu-card>
</template>
<script>
  import DiscussionApi from '../../../api/Discussion';
  import HTMLParser from '../../../helpers/HTMLStringParser';
  
  export default {
    name: "frequently-asked",
    data () {
      return {
        isLoading: true,
        isSaving: false,
        data: []
      }
    },
    methods: {
      goToQuestion(id) {
        let self = this;
        self.$router.push({
          name: 'QuestionThread',
          params: {
              id: id
          }
        });
      },
	  encode(title) {
	   return HTMLParser.encode(title);
	 }
    },
    mounted() {
      let self = this;
      self.isLoading = true;
      if (self.$store.state.discussion.frequentlyAsked.length > 0) {
        self.data = self.$store.state.discussion.frequentlyAsked;
        self.isLoading = false;
      }
      else DiscussionApi.getDiscussionFrequentlyAsked()
        .then(function (response) {
          self.isLoading = false;
          self.data = response.data;
          self.$store.commit('setDiscussionFrequentlyAsked', response.data);
        })
    }
  }
</script>
<style lang="less">
  #frequently-asked {
    .mu-card-header-title {
      padding: 0;
    }
    .mu-item-title {
      line-height: 1.3;
    }
    .mu-list {
      counter-reset: faq;
      .faq {
        position: relative;
        &:before {
          margin: -18px 0 0;
          counter-increment: faq;
          content: counter(faq);
          position: absolute;
          font-size: 24px;
          color: #0179d9;
          top: 50%;
          left: 16px;
        }
        .mu-item {
          padding-left: 50px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FrequentlyAsked.vue?3adfb8bf